<template>
  <div class="list-cars"
       v-if="listCar">
    <div class="list-cars_item"
         v-for="(car, carIndex) in listCar"
         v-bind:key="carIndex"
         v-bind:class="{ 'active' : currentCar.index === carIndex && carDetailsState,
                         'list-cars_item__mark' : currentCar.index === carIndex && !carDetailsState }">
      <!-- s Head Car -->
      <div class="list-cars_item-head"
           v-on:click="toggleCar( carIndex )">
        <div class="list-cars_photo">
          <div class="new-photo_image"
               v-if="car.photo"
               v-bind:style="{ 'background-image' : 'url(' + car.photo + ')' }">
          </div>
          <div class="list-cars_type" v-if="car.device">
            <img src="../assets/img/logo-car-universe.svg" v-if="car.device.type === 1">
            <img src="../assets/img/logo-car-mobicar.svg" v-else-if="car.device.type === 2">
            <img src="../assets/img/logo-car-x.svg" v-else-if="car.device.type === 3">
          </div>
        </div>
        <div class="list-cars_name-car m-title">
          {{car.name}}
        </div>
        <div class="list-cars_reg-id">
          {{car.registration_id}}
        </div>
        <div class="list-cars_user-name text-small-italic">
          {{car.owner.name}}
        </div>
        <div class="list-cars_short-state" v-if="stateCars[car.id]">
          <img :src="status"
               v-for="(status, statusIndex) in statusList[car.id]"
               v-bind:key="statusIndex">
        </div>
      </div>
      <!-- e Head Car -->
      <!-- s Details Car -->
      <div class="car-details" v-if="currentCar.index === carIndex && carDetailsState">
        <div class="car-details_empty"
             v-if="!stateCars[ currentCar.id ] && !routeCars[ currentCar.id ]">
          <div class="style-hr__solid">
          </div>
          <span class="s-title">Сведения для данного авто отсутствуют</span>
        </div>
        <div v-else>
          <!-- Nav Details -->
          <div class="car-details_nav">
            <div class="car-details_nav-item"
                 v-if="car.access_state && car.device.has_internet_connection"
                 v-on:click="changeContentType(1)"
                 v-bind:class="{ 'car-details_nav-item__active' : contentState === 1 }">
              <span>Управление</span>
            </div>
            <div class="car-details_nav-item car-details_nav-item__disabled"
                 v-else>
              <span>Управление</span>
            </div>

            <div class="car-details_nav-item"
                 v-if="car.access_history"
                 v-on:click="changeContentType(2)"
                 v-bind:class="{ 'car-details_nav-item__active' : contentState === 2 }">
              <span>Журнал</span>
            </div>
            <div class="car-details_nav-item car-details_nav-item__disabled"
                 v-else>
              <span>Журнал</span>
            </div>

            <div class="car-details_nav-item"
                 v-if="car.access_report"
                 v-bind:class="{ 'car-details_nav-item__active' : contentState === 3 }"
                 v-on:click="changeContentType(3)">
              <span>Статистика</span>
            </div>
            <div class="car-details_nav-item car-details_nav-item__disabled"
                 v-else>
              <span>Статистика</span>
            </div>

            <div class="car-details_nav-item"
                 v-if="car.access_settings && car.device.type === 1 "
                 v-bind:class="{ 'car-details_nav-item__active' : contentState === 4 }"
                 v-on:click="changeContentType(4)">
              <img src="../assets/img/settings2.svg">
            </div>
            <div class="car-details_nav-item"
                 v-if="car.device.type === 2 || car.device.type === 3"
                 v-bind:class="{ 'car-details_nav-item__active' : contentState === 5 }"
                 v-on:click="changeContentType(5)">
              <img src="../assets/img/settings2.svg">
            </div>
            <div class="car-details_nav-item car-details_nav-item__disabled"
                 v-if="!car.access_settings && car.device.type === 1">
              <img src="../assets/img/settings2.svg">
            </div>
          </div>
          <!-- Content Details -->
          <div>
						<!-- Management -->
						<Management v-if="contentState === 1">
						</Management>
						<!-- Journal -->
						<Journal v-if="contentState === 2">
						</Journal>
						<!-- Statistic -->
						<Statistic v-if="contentState === 3">
						</Statistic>
						<!-- Settings list -->
						<SettingsList v-if="contentState === 4">
						</SettingsList>
					</div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
  import Management    from './ControlPanel/Management'
  import Journal       from './ControlPanel/Journal'
  import Statistic     from './ControlPanel/Statistic'
  import SettingsList  from './ControlPanel/SettingsList'
  import { HTTP,HTTP_AUTH }      from '@/main'

  export default {
    data(){
      return{
        listCarPr : '',
      }
    },
    created(){
      this.$store.dispatch('controlPanelMenu', 1 );

      // Получение данных о всех автомобилях пользователя
      if( !this.listCar.length ){

        this.$connect(); // соединяем сокеты

        HTTP.get('cars/').then( response => {
          this.$store.dispatch('listCar', response.data);

          this.getUserData();
        }).catch( error => {
          if( parseInt(error.response.status) === 401 ){
            document.cookie = 'userToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            setTimeout(function () {
              window.location.reload();
            }, 100)
          }else{
            this.$store.dispatch('errorResponse', error );
          }
        });
      }

      // Проверяем список комманд
      this.$store.dispatch('changeCommandList')
    },
    computed: {
      contentState(){
        return this.$store.state.panels.car;
      },
      carDetailsState : function () {
        return this.$store.state.panels.carDetails;
      },
      currentCar(){
        return this.$store.state.cars.current;
      },
      listCar(){
        return this.$store.state.cars.list;
      },
      statusOptionPanel : function () {
        return this.$store.state.panels.option.status
      },
      stateCars : function(){
        return this.$store.state.cars.state
      },
      routeCars : function(){
        return this.$store.state.cars.route
      },
      statusList : function () {
        let listStatus = {};

        for(let key in this.stateCars){
          listStatus[key] = [];

          if( this.stateCars[key] ){
            if( this.stateCars[key].is_online === false ){
              listStatus[key].push( require('../assets/img/car_state/net_lost.svg') );
            }
            if( this.stateCars[key].is_in_evacuation === true ){
              listStatus[key].push( require('../assets/img/car_state/evas.svg') );
            }
            if( this.stateCars[key].is_in_route === true ){
              listStatus[key].push( require('../assets/img/car_state/road.svg') );
            }
            if( this.stateCars[key].engine  ){
              if( this.stateCars[key].engine.state_id === 6 ||
                this.stateCars[key].engine.state_id === 7 ||
                this.stateCars[key].engine.state_id === 8 ||
                this.stateCars[key].engine.state_id === 9 )
              {
                listStatus[key].push( require('../assets/img/car_state/autostart.svg') );
              }
            }
            if( this.stateCars[key].is_pre_heater_on === true ){
              listStatus[key].push( require('../assets/img/car_state/eng-hot.svg') );
            }
            if( this.stateCars[key].state === "protect" ){
              listStatus[key].push( require('../assets/img/car_state/lock.svg') );
            }else if( this.stateCars[key].state === "disarm" ){
              listStatus[key].push( require('../assets/img/car_state/unlock.svg') );
            }else if( this.stateCars[key].state === "alarm" ){
              listStatus[key].push( require('../assets/img/car_state/alarm.svg'), require('../assets/img/car_state/lock.svg') );
            }else if( this.stateCars[key].state === "wasalarm" ){
              listStatus[key].push( require('../assets/img/car_state/was-alarm.svg'), require('../assets/img/car_state/lock.svg') );
            }else if( this.stateCars[key].state === "hijacking" ){
              listStatus[key].push( require('../assets/img/car_state/stop.svg') );
            }else{
              listStatus[key].push( require('../assets/img/car_state/autoserv.svg') );
            }
          }
        }
        return listStatus;
      },
      remind : function(){
        return this.$store.state.panels.login.remind
      }
    },
    methods : {
      changeContentType : function ( index ) {
        if( index === 4 || index === 5 ){
          if( this.statusOptionPanel === 1 ){
            this.$store.dispatch('optionPanel', 0);
          }else{
            this.$store.dispatch('optionPanel', 1);
            this.$store.dispatch('optionPanelType', 2);
            this.$store.dispatch('controlPanelMenu', 4 );
          }
        }else{
          if( this.statusOptionPanel === 1 ){
            this.$store.dispatch('optionPanel', 0);
          }
          this.$store.dispatch('controlPanelMenu', index );
        }
      },
      toggleCar : function ( index ) {
        if( this.currentCar.index === index ){
          if( this.carDetailsState ){
            this.$store.dispatch('carDetailsState', false);
          }else{
            this.$store.dispatch('carDetailsState', true);
          }
        }else{
          this.$store.dispatch('toggleActiveCar', index );
          this.$store.dispatch('carDetailsState', true);
        }

        if( this.listCar[this.currentCar.index].device.type !== 1 && !this.listCar[this.currentCar.index].device.has_internet_connection ){
          this.$store.dispatch('controlPanelMenu', 5 );
          this.$store.dispatch('optionPanelType', 5);
          this.$store.dispatch('optionPanel', 1);
        }else{
          this.$store.dispatch('controlPanelMenu', 1 );
          this.$store.dispatch('optionPanel', 0);
        }
      },
			getUserData : function () {
        HTTP_AUTH.get('user/').then((response) => {
          this.$store.dispatch('userData', response );
        }).catch(( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      }
    },
    components : {
      Management,
      Journal,
      Statistic,
      SettingsList
    }
  }
</script>